import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { InvestmentsMacroResponse, fetchInvestmentsMacro } from "@features/investments/api";

export const macroQueryKey = ["investments", "macro"] as const;

export function useInvestmentsMacroQuery(): UseQueryResult<InvestmentsMacroResponse, Error> {
  return useQuery({
    queryKey: macroQueryKey,
    queryFn: fetchInvestmentsMacro,
    retry: false,
  });
}
